export default "__VITE_ASSET__45af1ed5__"